<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    {{ $route.meta.title }}
                </div>
                <div class="list-content">
                    <live-klass-adjust-list-component :liveklassType="`adjustDetail`" :liveKlassKey="liveKlassKey"></live-klass-adjust-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>

import LiveKlassAdjustListComponent from "@/components/liveklass/LiveKlassAdjustListComponent";

export default {
    name: "LiveKlassAdjustDetail",
    mixins: [],
    components: {LiveKlassAdjustListComponent},
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            liveKlassKey: Number(this.$route.params.idx),
        };
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
    },
    watch: {},
};
</script>
